var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('table',{staticStyle:{},attrs:{"id":"wrapper"}},[_c('tr',[_c('td',[_c('img',{attrs:{"width":"100px","src":"https://cdn-icons-png.flaticon.com/512/353/353912.png","alt":""}}),_c('br'),_c('br'),_c('h5',[_vm._v("Whoops, Something went wrong")])])])])
}]

export { render, staticRenderFns }